module.exports = __webpack_public_path__ + "static/media/grants_poster.16b78163.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/grants_poster.jpg
// module id = 174
// module chunks = 0